module.exports = __webpack_public_path__ + "img/DE01793.21559bd1.png";